import React, { useContext, useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { StudentContext } from '../../Context/StudentContext';
import AlertBox from '../AlertBox/AlertBox';

const Home = () => {
    const { getGeneralDetails, student, isSessionExpired } = useContext(StudentContext);

    useEffect(() => {
        getGeneralDetails()
    }, []);

    const renderStudentDetails = () => {
        return (
            <div className="container">
                <h2> Student details</h2>
                <table className="table table-borderless">
                    <tbody>
                        <tr>
                            <td><b>Name</b></td>
                            <td>{student.name}</td>
                        </tr>
                        <tr>
                            <td><b>Register number</b></td>
                            <td>{student.register_no}</td>
                        </tr>
                        <tr>
                            <td><b>Shift</b></td>
                            <td>{student.department.shift}</td>
                        </tr>
                        <tr>
                            <td><b>Department</b></td>
                            <td>{student.department.department}</td>
                        </tr>
                        <tr>
                            <td><b>Language Subject</b></td>
                            <td>{student.language}</td>
                        </tr>

                    </tbody>
                </table>
            </div>
        )
    }

    const renderNMEATBTDetails = () => {
        return (
            <div className="container">
                <h5>NME AT BT Subject Details</h5>
                <table className="table table-borderless">
                    <tbody>
                        <tr>
                            <td><b>Subject Name</b></td>
                            <td>{student.nme_subject.name}</td>
                        </tr>
                        <tr>
                            <td><b>Subject Code</b></td>
                            <td>{student.nme_subject.subject_code}</td>
                        </tr>
                        <tr>
                            <td><b>Department Handling</b></td>
                            <td>{student.nme_subject.department_handling.department}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        )
    }

    const renderChooseNMEButton = () => {
        return (
            <div className="text-center">
                <Link to='/choose-nme' className="btn btn-success">Select NME Subject</Link>
            </div>
        )
    }

    return (
        <div>
            {
                (isSessionExpired) ?
                    <AlertBox clasName="container" alertType={'danger'} heading={'Session Expired'} message={'Session Expired, Please logout and login again'} />
                    :
                    <div>
                        <div>{renderStudentDetails()}</div>
                        {
                            (student.nme_subject !== null) ?
                                <div>{renderNMEATBTDetails()}</div>
                                :
                                <div>{renderChooseNMEButton()}</div>
                        }
                    </div>
            }
        </div>
    );
}

export default Home;